(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/youtube-playlist/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/components/youtube-playlist/assets/javascripts/prescript.js');
'use strict';

var svs = svs || {};

svs.components = svs.components || {};
svs.components.youtube_playlist = svs.components.youtube_playlist || {};
svs.components.youtube_playlist.utils = svs.components.youtube_playlist.utils || {};


 })(window);